export const KEY_LOGIN = 'login'

export const getInitialState = () => ({
  loading: false,
})

export const setInitialState = (state) => {
  state[KEY_LOGIN] = getInitialState()
  return state
}
